import { createContext, useState, ReactNode, useEffect } from "react";
import { getCategories } from "~src/api/categories";
import { MapOfBrands } from "~src/types/brandMapping";
import { logError } from "~src/utils/logger";
type BrandMappingContextType = {
  mapOfBrandsContext: MapOfBrands[] | undefined;
  setMapOfBrandsContext: React.Dispatch<
    React.SetStateAction<MapOfBrands[] | undefined>
  >;

  mapOfBrandsFullResponseContext: MapOfBrands[] | undefined;
  setMapOfBrandsFullResponseContext: React.Dispatch<
    React.SetStateAction<MapOfBrands[] | undefined>
  >;

  mappedProductCategoryIds: number[] | undefined;
  setMappedProductCategoryIds: React.Dispatch<
    React.SetStateAction<number[] | undefined>
  >;

  productCategories: any;
  setProductCategories: React.Dispatch<React.SetStateAction<any>>;
};

const BrandMappingContextV3 = createContext<BrandMappingContextType | null>(
  null,
);

const BrandMappingProviderV3 = ({ children }: { children: ReactNode }) => {
  const [mapOfBrandsContext, setMapOfBrandsContext] = useState<
    MapOfBrands[] | undefined
  >([]);
  const [mapOfBrandsFullResponseContext, setMapOfBrandsFullResponseContext] =
    useState<MapOfBrands[] | undefined>([]);
  const [mappedProductCategoryIds, setMappedProductCategoryIds] = useState<
    number[] | undefined
  >();
  const [productCategories, setProductCategories] = useState<any[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      if (!mappedProductCategoryIds || mappedProductCategoryIds.length === 0)
        return;

      try {
        const responses = await Promise.all(
          mappedProductCategoryIds.map(async (id) => {
            const response = await getCategories(id);
            return response;
          }),
        );

        setProductCategories(responses.flat());
      } catch (error) {
        logError(`Error fetching categories: ${error}`);
      }
    };
    fetchCategories();
  }, [mappedProductCategoryIds]);

  const contextValue = {
    mapOfBrandsContext,
    setMapOfBrandsContext,

    mapOfBrandsFullResponseContext,
    setMapOfBrandsFullResponseContext,

    mappedProductCategoryIds,
    setMappedProductCategoryIds,

    productCategories,
    setProductCategories,
  };

  return (
    <BrandMappingContextV3.Provider value={contextValue}>
      {children}
    </BrandMappingContextV3.Provider>
  );
};

export { BrandMappingContextV3, BrandMappingProviderV3 };
